<template>
	<div class="editor_box" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color,paddingTop:editablePageConfig.editable_page_config_content.margin_top,paddingBottom:editablePageConfig.editable_page_config_content.margin_bottom}">
    <div class="editor_con">
      <div v-html="editablePageConfig.editable_page_config_content.editor[0]"></div>
    </div>
    <!--<div @click="showName">测试</div>-->
	</div>
</template>
<script>
export default {
  name: 'Model20',
  data () {
    return {}
  },
  props: ['editablePageConfig'],
  components: {

  },
  computed: {

  },
  methods: {
    showName () {
      console.log(this.editablePageConfig)
    }
  }
}
</script>
<style lang="scss" scoped>
.editor_con {
	background: #ffffff;
  padding: 10px;
}
</style>
